import {ChangeEvent, ReactElement, useState} from 'react'
import {FormControl, TextField, Button, MenuItem, InputLabel, Select} from '@material-ui/core'
import {Trans} from 'react-i18next'
import {PixAccountTypes} from '@bdswiss/common-enums'

import messages from '../../../../../../../assets/messages'
import {PIX_PAYOUT_FIELD_NAMES, PIX_PAYOUT_DEFAULT_FIELD_VALUES} from '../../../constants'
import {useStyles} from './styles'

type PayRetailerFieldsProps = {
  paymentFields: Record<string, any> | null
  onPaymentMethodSet: (fieldValues) => void
  onClose: () => void
}

const pixAccountTypesOptions = Object.values(PixAccountTypes)

export function PixPayoutFields(props: PayRetailerFieldsProps): ReactElement {
  const classes = useStyles()
  const {paymentFields, onPaymentMethodSet, onClose} = props
  const [formFieldsValues, setFormFieldsValues] = useState(
    paymentFields || PIX_PAYOUT_DEFAULT_FIELD_VALUES,
  )

  const fieldsVisibilityMap = {
    [PIX_PAYOUT_FIELD_NAMES.pixCustomerIdentity]: true,
    [PIX_PAYOUT_FIELD_NAMES.pixAccountType]: true,
    [PIX_PAYOUT_FIELD_NAMES.pixAccountId]:
      formFieldsValues.pixAccountType &&
      formFieldsValues.pixAccountType !== PixAccountTypes.cpf.value,
  }
  const isSubmitDisabled = Object.keys(formFieldsValues).some((key) => {
    const isVisible = fieldsVisibilityMap[key]
    const value = formFieldsValues[key]
    return isVisible && !value.toString().trim()
  })

  const handleTextFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {value, name} = event.target
    setFormFieldsValues((prevValues) => ({...prevValues, [name]: value}))
  }

  const handleSelectFieldChange = (
    event: ChangeEvent<{name?: string | undefined; value: unknown}>,
  ) => {
    const {value, name} = event.target
    if (!name || !value) return

    setFormFieldsValues((prevValues) => ({...prevValues, [name]: value}))
  }

  const handleSave = () => {
    onPaymentMethodSet(formFieldsValues)
    onClose()
  }

  const pixAccountIdLabelsMap = {
    [PixAccountTypes.cpf.value]: <Trans {...messages.personalIdentificationNumber} />,
    [PixAccountTypes.email.value]: <Trans {...messages.email} />,
    [PixAccountTypes.phone.value]: <Trans {...messages.phoneNumber} />,
    [PixAccountTypes.evp.value]: <Trans {...messages.evp} />,
  }

  return (
    <>
      <FormControl fullWidth>
        <InputLabel>
          <Trans {...messages.pixAccountType} />
        </InputLabel>
        <Select
          name={PIX_PAYOUT_FIELD_NAMES.pixAccountType}
          value={formFieldsValues.pixAccountType}
          onChange={handleSelectFieldChange}
        >
          {pixAccountTypesOptions.map(({value, label}) => (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl fullWidth>
        <TextField
          required
          type="text"
          name={PIX_PAYOUT_FIELD_NAMES.pixCustomerIdentity}
          value={formFieldsValues.pixCustomerIdentity}
          label={<Trans {...messages.personalIdentificationNumber} />}
          onChange={handleTextFieldChange}
        />
      </FormControl>
      {fieldsVisibilityMap['pixAccountId'] ? (
        <FormControl fullWidth>
          <TextField
            required
            type="text"
            name={PIX_PAYOUT_FIELD_NAMES.pixAccountId}
            value={formFieldsValues.pixAccountId}
            label={pixAccountIdLabelsMap[formFieldsValues.pixAccountType]}
            onChange={handleTextFieldChange}
          />
        </FormControl>
      ) : null}
      <Button
        disabled={isSubmitDisabled}
        variant="contained"
        color="primary"
        onClick={handleSave}
        className={classes.button}
      >
        <Trans {...messages.saveAndContinue} />
      </Button>
    </>
  )
}
